import type React from "react";

interface HeadingProps extends React.HtmlHTMLAttributes<HTMLHeadingElement> {
	tagName: "h1" | "h2" | "h3" | "h4" | "h5" | "h6";
	styleType?: "display" | "bold" | "semibold" | "medium" | "regular";
	children: string | JSX.Element | React.ReactNode;
	balanceText?: boolean;
}

const sizeMap = {
	h1: "text-3xl sm:text-5xl",
	h2: "text-2xl sm:text-4xl",
	h3: "text-xl sm:text-3xl",
	h4: "text-lg sm:text-2xl",
	h5: "text-lg sm:text-xl",
	h6: "text-lg sm:text-lg",
} as const;

const styleMap = {
	display: "font-black",
	bold: "font-bold",
	semibold: "font-semibold",
	medium: "font-medium",
	regular: "font-normal",
} as const;

const tagStyleDefault = {
	h1: "display",
	h2: "medium",
	h3: "medium",
	h4: "regular",
	h5: "medium",
	h6: "medium",
} as const;

export const Heading = ({
	className,
	tagName,
	styleType,
	balanceText = true,
	children,
}: HeadingProps) => {
	const TagName = tagName;
	return (
		<TagName
			className={`${balanceText ? "text-balance" : ""} break-words ${sizeMap[tagName]} ${
				styleType ? styleMap[styleType] : styleMap[tagStyleDefault[tagName]]
			} ${className}`}
		>
			{children}
		</TagName>
	);
};
